/**
 * Sticky
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
"use strict";
import {
  WINDOW,
  CLASS_HEADER,
  CLASS_HEADER_BOTTOM,
  CLASS_HEADER_TOP,
  CLASS_MAIN_CONTENT
} from "@utils/constants";
import { isExists, isMobile, isTablet } from "@utils/validate";

/**
 * Sticky thisect
 */
const Sticky = function () {
  // const CLASS_HEADER = ".header";
  const IS_STICKY = "sticky";

  /**
   * addSticky function
   */
  this.addSticky = () => {
    $(CLASS_HEADER).addClass(IS_STICKY);
  };
  /**
   * addSticky PC function
   */
  this.addStickyPC = () => {
    $(CLASS_HEADER_BOTTOM).addClass(IS_STICKY);
  };
  /**
   * removeSticky function
   */
  this.removeSticky = () => {
    $(CLASS_HEADER).removeClass(IS_STICKY);
  };
  /**
   * removeSticky function
   */
  this.removeStickyPC = () => {
    $(CLASS_HEADER_BOTTOM).removeClass(IS_STICKY);
  };

  /**
   * handleStickMenu
   * @return {void}
   */
  this.init = function () {
    let self = this;
    WINDOW.on("scroll resize", function (e) {
      e.preventDefault();
      // if (isExists(CLASS_HEADER) && isMobile()) {
      if (isExists(CLASS_HEADER) && (isMobile() || isTablet())) {
        self.removeStickyPC();
        const getHeightHeader = $(CLASS_HEADER).innerHeight();
        if (WINDOW.scrollTop() > 0) {
          self.addSticky();
          $(CLASS_MAIN_CONTENT).css("margin-top", getHeightHeader);
        } else {
          self.removeSticky();
          $(CLASS_MAIN_CONTENT).removeAttr("style");
        }
      } else if (isExists(CLASS_HEADER_BOTTOM)) {
        self.removeSticky();
        const getHeightHeaderBottom = $(CLASS_HEADER_BOTTOM).innerHeight();
        const getHeightHeaderTop = $(CLASS_HEADER_TOP).innerHeight();
        if (WINDOW.scrollTop() > getHeightHeaderTop) {
          self.addStickyPC();
          $(CLASS_MAIN_CONTENT).css("margin-top", getHeightHeaderBottom);
        } else {
          self.removeStickyPC();
          $(CLASS_MAIN_CONTENT).removeAttr("style");
        }
      } else {
        self.removeStickyPC();
        $(CLASS_MAIN_CONTENT).removeAttr("style");
      }
    });

    WINDOW.trigger("scroll");
  };

  return this.init();
};

export default Sticky;
